import React, { useCallback, useMemo, useRef, useState } from 'react'
import MinScreen from '../../../assets/icon/classscreen-minscreen.svg'
import MaxScreen from '../../../assets/icon/classscreen-maxscreen.svg'
import { useEffect } from 'react'
import { startMedia, switchHandlder } from 'utils/webrtc/peerConnection'

function CallScreen() {
  const [expanded, setExpanded] = useState()

  const [localVideo, setlocalVideo] = useState(null)
  console.log('🚀 ~ CallScreen ~ localVideo:', localVideo)

  const [remoteVideo, setRemoteVideo] = useState(null)
  console.log('🚀 ~ CallScreen ~ remoteVideo:', remoteVideo)

  useEffect(() => {
    startMedia(setlocalVideo)
    switchHandlder(setRemoteVideo)
  }, [])

  const localVideoElement = useMemo(
    () => (
      <video
        ref={(vid) => (vid.srcObject = localVideo)}
        className="w-full min-h-full bg-cover "
        autoPlay
        playsInline
        // src={localVideo}
      ></video>
    ),
    [localVideo]
  )

  const remoteVideoElement = useMemo(
    () => (
      <video
        ref={(vid) => (vid.srcObject = remoteVideo)}
        className="w-full min-h-full bg-cover "
        autoPlay
        playsInline
        // src={localVideo}
      ></video>
    ),
    [remoteVideo]
  )

  return (
    <div className="h-full w-full relative overflow-hidden rounded-lg border-2 border-solid border-[white] my-3 flex">
      {expanded !== 2 && (
        <div className="flex-1 relative h-full">
          {expanded === 1 ? (
            <div className="p-2 bg-[black] absolute right-0 bg-opacity-40 cursor-pointer ">
              <img src={MinScreen} alt="" onClick={() => setExpanded()} />
            </div>
          ) : (
            <div className="p-2 bg-[black] absolute right-0 bg-opacity-40 cursor-pointer rounded-bl-[5px]">
              <img src={MaxScreen} alt="" onClick={() => setExpanded(1)} />
            </div>
          )}
          {localVideo ? (
            localVideoElement
          ) : (
            <img
              alt="my-screen"
              className="w-full min-h-full bg-cover "
              src="https://media.istockphoto.com/id/1445407379/video/screen-view-of-yong-black-man-waving-hand-and-talking-during-a-video-call-looking-at-camera.jpg?s=640x640&k=20&c=V2ZZ6qVBrA3XOpmo5A7lRH-Bw1308WAoQhoppBlNM04="
            />
          )}
          {/* <video
            ref={(video) => video.srcObject = localStream}
            className="w-full min-h-full bg-cover "
            autoPlay
            playsInline
            src=" "
          ></video> */}
        </div>
      )}
      {expanded !== 1 && (
        <div className="flex-1 relative h-full">
          {expanded === 2 ? (
            <div className="p-2 bg-[black] absolute right-0 bg-opacity-40 cursor-pointer ">
              <img src={MinScreen} alt="" onClick={() => setExpanded()} />
            </div>
          ) : (
            <div className="p-2 bg-[black] absolute right-0 bg-opacity-40 cursor-pointer">
              <img src={MaxScreen} alt="" onClick={() => setExpanded(2)} />
            </div>
          )}
          {remoteVideo ? (
            remoteVideoElement
          ) : (
            <img
              alt="second-screen"
              className="w-full min-h-full bg-cover "
              src="https://www.shutterstock.com/shutterstock/videos/26197976/thumb/1.jpg?ip=x480"
            />
          )}
          {/* <video
            ref={localVideoRef}
            className="w-full min-h-full bg-cover"
            autoPlay
            playsInline
            src=" "
          ></video> */}
        </div>
      )}
      <div className="p-2 bg-[black] absolute right-[36px] bg-opacity-40 text-[white] text-sm rounded-bl-[5px]">
        Time Remaining: 55:00
      </div>
    </div>
  )
}

export default CallScreen
